import { render, staticRenderFns } from "./Kavosz.vue?vue&type=template&id=66c87b8e"
import script from "./Kavosz.vue?vue&type=script&lang=js"
export * from "./Kavosz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports